export default __webpack_public_path__ + "static/aaditya-presenting-219291e7eb9a38afe612c74db1ff73da.webp";